module.exports = __webpack_public_path__ + "img/SMT_52_Martin_Thoo.a1036e9c.jpg";